const _ = require('lodash');
const jQuery = require('jquery');

import 'mailcheck';

require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/widgets/autocomplete');

require('jquery-validation');

require('bootstrap');
require('popper.js');

window.$ = window.jQuery = jQuery;
window._ = _;
